export default __webpack_public_path__ + "static/media/fonts/AlegreyaSans-Regular.faa3c83d.ttf";